// extracted by mini-css-extract-plugin
export default {"option":"material-option_option__SXmYB","label":"material-option_label__c7BVD","active":"material-option_active__k+tHw","image":"material-option_image__dmSNu"};